import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { API_AUTH_TYPES, API_ROUTES, ApiRequest } from '../api';
import { useQuery } from 'react-query';
// Custom hook name starts with "use"
const useConfig = () => {
    const params = useParams()
    const householdId = params.household_id || 'me';

    const { data: users, isLoading } = useQuery({
        queryKey: ['users', householdId],
        queryFn: new ApiRequest(API_ROUTES.USERS, API_AUTH_TYPES.CLIENT).getFn({ endpoint: 'get_household_users', queryParams: { household_id: householdId } })
    })

    // Calculate isAdvisor from current location - ensure it's always a boolean
    const isAdvisor = window.location.pathname.split('/')[1] === 'crm';
    const baseUrl = isAdvisor ? `/crm/households/${householdId}` : '/';

    // Use useState to manage the config with proper defaults
    const [config, setConfig] = useState(() => {
        return {
            householdId,
            baseUrl,
            isAdvisor,
            users: users || null
        };
    });

    useEffect(() => {
        setConfig(prevConfig => ({
            ...prevConfig,
            householdId,
            baseUrl,
            isAdvisor,
            users: users || null
        }));
    }, [users, isLoading, householdId, baseUrl, isAdvisor]);

    // Return the config
    return config;
}

export default useConfig;
